import { gql } from "@apollo/client";

export const BROWSER_CALL_AGENT_SIGNALING = gql`
  subscription browserCallAgentSignaling($agentId: ID!) {
    browserCallAgentSignaling(agentId: $agentId) {
      roomId
      event
      sdp
      candidate
      fromRole
      reason
      call {
        id
        roomId
        agentId
        status
        mediaMode
        customerName
        customerIdentifier
        channel
        inboxId
        linkExpiresAt
      }
    }
  }
`;

export const BROWSER_CALL_GUEST_SIGNALING = gql`
  subscription browserCallGuestSignaling($roomId: String!) {
    browserCallGuestSignaling(roomId: $roomId) {
      roomId
      event
      sdp
      candidate
      fromRole
      reason
      call {
        id
        roomId
        status
        mediaMode
        customerName
      }
    }
  }
`;
